export default __webpack_public_path__ + "static/media/02.03.034.7d190b55.png";